import React, { FC } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Header, Body, Typography } from "../styled";
import Checkbox from "@mui/material/Checkbox";

const WorkSkills: FC = () => {
    return (
      <Box mt={1}>
          <Header>
              <Box>
                <FormControlLabel
                      label="на пищущей машинке"
                      control={<Checkbox defaultChecked />}
                />
              </Box>
              <Box>
                    <FormControlLabel
                        label="на компьютере"
                        control={<Checkbox defaultChecked />}
                    />
              </Box>
              <Box>
                    <FormControlLabel
                        label="стенографии"
                        control={<Checkbox defaultChecked />}
                    />
              </Box>
              <Box>
                    <FormControlLabel
                        label="имеет водительские права"
                        control={<Checkbox defaultChecked />}
                  />
              </Box>
          </Header>
        <Body>
        <Typography sx={{mt: 2,mb: 2, ml: 1}}> Дополнительное сведения: </Typography>
        <TextField 
            label="Outlined secondary" 
            focused 
            sx={{ color: "#858585", height: "150px"}}
            />
        </Body>
      </Box>
    );
};

export default WorkSkills;